export default class loaderManager {
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        this.$loader = document.getElementById('l-loader');
        this.$loaderBg = document.querySelectorAll('#l-loader__cover>*');
        this.$loaderText = document.querySelectorAll('#l-loader-text');
        this.$loaderBorder = document.querySelector('.pace');

    }
    init(){

        this.$loaderBorder = document.querySelector('.pace');

        TweenMax.to(this.$loaderText,1.0,{
            opacity:0,
            scale: 0.96,
            ease:this.manager.ease,
            onComplete:() => {
                TweenMax.to(this.$loaderBorder,1.0,{
                    width:'0%',
                    ease:this.manager.ease,
                    onStart:() => {
                        TweenMax.to([this.$loaderBg[0],this.$loaderBg[1]],1.6,{
                            delay:1.4,
                            opacity:0,
                            ease:this.manager.ease,
                            onStart: () => {
                                this.manager.loadPage();
                            },
                            onComplete:() => {
                                this.$loader.parentNode.removeChild(this.$loader);
                            }
                        });
                        TweenMax.to(this.$loaderBorder, .1,{
                            delay:2,
                            display:'none',
                            ease:this.manager.ease,
                        });
                    }
                });
            }
        });

    }


}